import moment from 'moment';

export const calculations = {
    saveRegularly: (/** @type {number} */ periodicAmount, /** @type {number} */ deposit, /** @type {number} */ months, /** @type {number} */ interestRate, /** @type {boolean} */ applyInterestAtEnd) => {
        const showMyWorkings = !!localStorage.getItem('show-my-workings');
        const dailyInterestRate = (interestRate / 100.0) / 365;
        let savedSoFar = deposit;
        let interest = 0;
        let currentPeriodStartDate = moment();
        let endOfNextPeriod = moment().add(1, 'months');

        let dayOfMonth = currentPeriodStartDate.date()

        let totalDays = 0;
        for (let i = 0; i < months; i++) {
            const days = endOfNextPeriod.diff(currentPeriodStartDate, 'days');
            totalDays += days;

            let accruingInterest = 0;
            for (let i = 0; i < days; i++) {
                accruingInterest += savedSoFar * dailyInterestRate;
            }

            if (applyInterestAtEnd === false) {
                // let roundedInterest = Math.round((accruingInterest) * 1000.0) / 1000.0;
                // savedSoFar += roundedInterest;
                // interest += roundedInterest;
                savedSoFar += accruingInterest;
                interest += accruingInterest;
            } else {
                // let roundedInterest = Math.round((accruingInterest) * 1000.0) / 1000.0;
                // interest += roundedInterest;
                interest += accruingInterest;
            }

            savedSoFar += periodicAmount;

            if (showMyWorkings) {
                console.log(`End of month. ${currentPeriodStartDate.format()} - ${endOfNextPeriod.format()} days: ${days} closing balance: ${savedSoFar} accrued: ${interest} (${totalDays})`);
            }

            currentPeriodStartDate.add(1, 'months');
            endOfNextPeriod.add(1, 'months');

            currentPeriodStartDate.date(Math.min(dayOfMonth, currentPeriodStartDate.daysInMonth()));
            endOfNextPeriod.date(Math.min(dayOfMonth, endOfNextPeriod.daysInMonth()));
        }

        if (applyInterestAtEnd === true) {
            savedSoFar += interest;
        }

        return {
            saved: Math.round((savedSoFar + Number.EPSILON) * 100) / 100,
            interest: Math.round((interest + Number.EPSILON) * 100) / 100,
        }
    },


};